/** @format */

import axios from 'axios';
import axiosInstance from './axios';

export async function getPromptResult(payload) {
  return await axiosInstance.post('/retailware/conversational_bi', payload);
}
export async function getPromptInsights(payload) {
  return await axiosInstance.post('/retailware/ask_sam_insights', payload);
}
export async function getDrillDownAi(payload) {
  const response = await axios.post(
    'https://rwa1.navaantrix.com/retailware/ask_sam_drilldown',
    payload
  );
  return response;
}
